<template>
	<div class="baseadddpercent">
		<el-row>
			<el-col :span="8"><span style="color:#ffffff">占</span></el-col>
			<el-col :span="8">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{ p_name }}</span>
					</div>
					<el-form label-width="80px" size="mini">
						<el-form-item label="方案名称"><el-input v-model="percwinfo.c_name" @input="changeinput" type="text"></el-input></el-form-item>
						<el-form-item label="提成比例">
							<el-input placeholder="请输入比例" v-model="percwinfo.price" @input="changeinput">
								<template slot="append">
									%
								</template>
							</el-input>
						</el-form-item>
						<el-form-item label="备  注"><el-input v-model="percwinfo.remark" @input="changeinput" type="textarea" row="5"></el-input></el-form-item>
						<el-form-item size="medium" style="padding-left:15%">
							<el-button type="success" @click="savepayrule" size="mini">保存</el-button>
							<el-button @click="rebacksetscheme" size="mini">返回</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
			<el-col :span="8"><span style="color:#ffffff">占</span></el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			percwinfo: {
				c_id: '',
				c_name: '',
				remark: '',
				p_type: '',
				price: 0
			},
			p_name:'',
			paylist: [],
			ischange: false
		};
	},
	mounted() {},
	methods: {
		init(param) {
			if (param != '' && param != undefined) {
				this.p_name = param.p_name;
				if (param.percwinfo != undefined) {
					if (param.percwinfo.c_id != undefined) this.percwinfo.c_id = param.percwinfo.c_id;
					if (param.percwinfo.c_name != undefined) this.percwinfo.c_name = param.percwinfo.c_name;
					if (param.percwinfo.remark != undefined) this.percwinfo.remark = param.percwinfo.remark;
					if (param.percwinfo.p_type != undefined) this.percwinfo.p_type = param.percwinfo.p_type;
					if (param.percwinfo.price != undefined) this.percwinfo.price = param.percwinfo.price;
				} else {
					(this.percwinfo = {
						c_id: '',
						c_name: '',
						remark: '',
						p_type: '',
						price: 0
					}),
						(this.paylist = []),
						(this.ischange = false);
				}
				this.isedit = param.isedit;
				this.GetCurrentscheme();
			}
		},
		GetCurrentscheme() {
			var that = this;
			if (this.percwinfo.c_id != '' && this.percwinfo.c_id != undefined) {
				var paraminfo = {
					c_id: this.percwinfo.c_id,
					ismain: 0
				};
				this.$apipost.get.Getscheme({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						if (res.paylist != undefined) {
							that.paylist = res.paylist;
							if (that.paylist.length > 0) {
								that.percwinfo.price = parseFloat(that.paylist[0].price);
							}
						} else {
							this.$tool.message('读取方案失败，请重新打开', 0);
						}
					}
				});
			}
		},
		//保存财务方案
		savepayrule() {
			if (this.percwinfo.c_name == '') {
				this.$tool.message('请输入方案名称', 0);
				return false;
			}
			if(isNaN(parseFloat(this.percwinfo.price))){
				this.$tool.message('请输入比例', 0);
				return false;
			}
			else{
				if (parseFloat(this.percwinfo.price) == 0) {
					var that=this;
					this.$confirm('您设置的比例为0，确认要保存吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						closeOnClickModal: false
					})
						.then(() => {
							that.savepayrule2();
						})
				}
				else if(parseFloat(this.percwinfo.price)<0){
					this.$tool.message('比例必须大于0', 0);
					return false;
				}
				else{
					this.savepayrule2();
				}
			}
		},
		savepayrule2(){
			var that = this;
			var paylist = [
				{
					c_id: this.percwinfo.c_id,
					c_name: this.percwinfo.c_name,
					remark: this.percwinfo.remark,
					p_type: this.percwinfo.p_type,
					price: this.percwinfo.price,
					userid: localStorage.getItem('userid')
				}
			];
			this.$apipost.post.Savescheme({ paraminfo: paylist }).then(res => {
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					that.ischange = false;
					that.rebacksetscheme();
				} else {
					this.$tool.message(res.message, 0);
				}
			});
					
		},
		rebacksetscheme() {
			if (this.ischange) {
				this.$confirm('您的信息有更改，确定放弃保存吗?', '提示', {
					confirmButtonText: '放弃',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.$emit('reback', {});
				});
			} else {
				this.$emit('reback', {});
			}
		},
		changeinput() {
			this.ischange = true;
		}
	}
};
</script>
